// extracted by mini-css-extract-plugin
module.exports = {"resourcesSearch":"styles_resourcesSearch__jkTuH","input":"styles_input__toLsh","inputActive":"styles_inputActive__T4GcR"};